var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9928 5.37553 18.6245 0.00717187 12 0ZM12 21C7.02942 21 3 16.9706 3 12C3 7.02942 7.02942 3 12 3C16.9706 3 21 7.02942 21 12C20.9945 16.9683 16.9683 20.9945 12 21Z",
    fill: "#7161ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.0911C12.8284 15.0911 13.5 14.4195 13.5 13.5911V6.59109C13.5 5.76267 12.8284 5.09109 12 5.09109C11.1716 5.09109 10.5 5.76267 10.5 6.59109V13.5911C10.5 14.4195 11.1716 15.0911 12 15.0911Z",
    fill: "#7161ba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0051 19C12.8336 19 13.5051 18.3284 13.5051 17.5C13.5051 16.6716 12.8336 16 12.0051 16C11.1767 16 10.5051 16.6716 10.5051 17.5C10.5051 18.3284 11.1767 19 12.0051 19Z",
    fill: "#7161ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPurple);
export default __webpack_public_path__ + "static/media/exclamationPurple.ebbace7415ecfa7c61bbc6e8f2bf7a0b.svg";
export { ForwardRef as ReactComponent };